import * as React from 'react';
import {
  IconMapMetroEkb16,
  IconMapMetroKzn16,
  IconMapMetroMsk16,
  IconMapMetroNN16,
  IconMapMetroNovosib16,
  IconMapMetroSam16,
  IconMapMetroSpb16,
} from '@cian/ui-kit-design-tokens/icons';

import { TUndergroundType } from '../../../../../../types/newbuildingsCompare';

const METRO_ICONS_MAP: Record<TUndergroundType, React.ReactNode> = {
  mow: <IconMapMetroMsk16 color="current_color" />,
  spb: <IconMapMetroSpb16 color="current_color" />,
  ekb: <IconMapMetroEkb16 color="current_color" />,
  kzn: <IconMapMetroKzn16 color="current_color" />,
  nsk: <IconMapMetroNovosib16 color="current_color" />,
  smr: <IconMapMetroSam16 color="current_color" />,
  nn: <IconMapMetroNN16 color="current_color" />,
};

export function metroIconMapper(undergroundType?: TUndergroundType | null): React.ReactNode {
  return METRO_ICONS_MAP[undergroundType ?? 'mow'] ?? METRO_ICONS_MAP.mow;
}
